// import React, { useState, useEffect } from "react";
// import { Modal, Button, Alert, Spinner } from "react-bootstrap";
// import { toast } from "react-toastify";
// import { getDatabase, ref, get } from "firebase/database";
// import { app } from "../../../Doctor/Firebase/firebase.config";

// const database = getDatabase(app);

// // ==================== STYLES ====================
// const styles = {
//   modalContent: {
//     borderRadius: '16px',
//     border: 'none',
//     boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden'
//   },
//   modalHeader: {
//     background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
//     color: 'white',
//     padding: '20px 30px',
//     borderBottom: 'none'
//   },
//   doctorInfo: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '15px'
//   },
//   doctorAvatar: {
//     width: '60px',
//     height: '60px',
//     borderRadius: '50%',
//     backgroundColor: 'white',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     fontSize: '24px',
//     fontWeight: 'bold',
//     color: '#4285f4'
//   },
//   doctorDetails: {
//     flex: 1
//   },
//   doctorName: {
//     fontSize: '20px',
//     fontWeight: '600',
//     margin: 0,
//     color: 'white'
//   },
//   doctorSpeciality: {
//     fontSize: '14px',
//     opacity: 0.9,
//     margin: 0,
//     color: 'white'
//   },
//   modalBody: {
//     padding: '30px',
//     backgroundColor: '#f8f9fa',
//     minHeight: '500px'
//   },
//   progressBar: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     marginBottom: '30px',
//     position: 'relative',
//     backgroundColor: 'white',
//     padding: '20px',
//     borderRadius: '12px',
//     boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
//   },
//   progressStep: {
//     flex: 1,
//     textAlign: 'center',
//     position: 'relative',
//     zIndex: 2
//   },
//   progressCircle: {
//     width: '40px',
//     height: '40px',
//     borderRadius: '50%',
//     backgroundColor: '#e0e0e0',
//     color: '#666',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     margin: '0 auto 8px',
//     fontWeight: 'bold',
//     fontSize: '16px',
//     transition: 'all 0.3s ease'
//   },
//   progressCircleActive: {
//     backgroundColor: '#4285f4',
//     color: 'white',
//     boxShadow: '0 4px 12px rgba(66, 133, 244, 0.4)'
//   },
//   progressLabel: {
//     fontSize: '12px',
//     color: '#666',
//     fontWeight: '500'
//   },
//   progressLabelActive: {
//     color: '#4285f4',
//     fontWeight: '600'
//   },
//   stepContainer: {
//     backgroundColor: 'white',
//     padding: '30px',
//     borderRadius: '12px',
//     boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
//     minHeight: '400px'
//   },
//   stepTitle: {
//     fontSize: '22px',
//     fontWeight: '700',
//     color: '#333',
//     marginBottom: '25px',
//     paddingBottom: '15px',
//     borderBottom: '3px solid #4285f4'
//   },
//   calendarControls: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '20px',
//     padding: '15px',
//     backgroundColor: '#f8f9fa',
//     borderRadius: '8px'
//   },
//   monthYearDisplay: {
//     fontSize: '18px',
//     fontWeight: '600',
//     color: '#333'
//   },
//   navButton: {
//     backgroundColor: '#4285f4',
//     color: 'white',
//     border: 'none',
//     padding: '8px 16px',
//     borderRadius: '6px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '600',
//     transition: 'all 0.2s ease',
//     '&:hover': {
//       backgroundColor: '#3367d6',
//       transform: 'translateY(-1px)'
//     },
//     '&:disabled': {
//       backgroundColor: '#ccc',
//       cursor: 'not-allowed',
//       transform: 'none'
//     }
//   },
//   calendarGrid: {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(7, 1fr)',
//     gap: '8px',
//     marginBottom: '20px'
//   },
//   calendarDay: {
//     textAlign: 'center',
//     padding: '8px',
//     fontSize: '12px',
//     fontWeight: '600',
//     color: '#666',
//     backgroundColor: '#f1f3f4',
//     borderRadius: '4px'
//   },
//   dateCell: {
//     minHeight: '60px',
//     padding: '8px',
//     borderRadius: '8px',
//     border: '2px solid #e0e0e0',
//     textAlign: 'center',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     backgroundColor: 'white',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center'
//   },
//   dateCellDisabled: {
//     backgroundColor: '#f5f5f5',
//     color: '#ccc',
//     cursor: 'not-allowed',
//     border: '2px solid #f0f0f0'
//   },
//   dateCellSelected: {
//     border: '2px solid #4285f4',
//     backgroundColor: '#e8f0fe',
//     transform: 'scale(1.05)'
//   },
//   dateCellToday: {
//     border: '2px solid #34a853',
//     fontWeight: 'bold'
//   },
//   dateNumber: {
//     fontSize: '16px',
//     fontWeight: 'bold',
//     color: '#333'
//   },
//   dateIndicator: {
//     fontSize: '10px',
//     color: '#4285f4',
//     marginTop: '2px'
//   },
//   highlightBox: {
//     backgroundColor: '#e8f0fe',
//     padding: '15px',
//     borderRadius: '8px',
//     marginBottom: '15px',
//     border: '1px solid #4285f4'
//   },
//   btnPrimary: {
//     backgroundColor: '#4285f4',
//     border: 'none',
//     padding: '12px 30px',
//     fontSize: '15px',
//     fontWeight: '600',
//     borderRadius: '8px',
//     transition: 'all 0.3s ease',
//     '&:hover': {
//       backgroundColor: '#3367d6',
//       transform: 'translateY(-2px)'
//     }
//   }
// };

// const DatePickerModal = ({ show, handleClose, doctor, onDateSelect }) => {
//   const [loading, setLoading] = useState(false);
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [doctorSchedule, setDoctorSchedule] = useState(null);
  
//   // Fetch doctor schedule
//   useEffect(() => {
//     if (!doctor || !show) return;

//     const fetchScheduleData = async () => {
//       try {
//         setLoading(true);
        
//         console.log("Fetching schedule for doctor:", doctor.uid);
        
//         const scheduleRef = ref(database, `doctor/${doctor.uid}/schedule`);
//         const scheduleSnapshot = await get(scheduleRef);
        
//         if (scheduleSnapshot.exists()) {
//           const scheduleData = scheduleSnapshot.val();
//           console.log("Raw schedule data:", scheduleData);
          
//           const scheduleKey = Object.keys(scheduleData)[0];
//           if (scheduleKey) {
//             const schedule = scheduleData[scheduleKey];
//             setDoctorSchedule({
//               ...schedule,
//               startDate: new Date(schedule.startDate),
//               endDate: new Date(schedule.endDate)
//             });
//             console.log("Processed schedule:", schedule);
//           }
//         } else {
//           console.log("No schedule found for this doctor");
//           toast.warning("Doctor schedule not available. Please ask the doctor to set their schedule.");
//         }
//       } catch (error) {
//         console.error("Error fetching schedule:", error);
//         toast.error("Failed to load schedule");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchScheduleData();
//   }, [doctor, show]);

//   // Generate calendar days
//   const generateCalendarDays = () => {
//     const year = currentMonth.getFullYear();
//     const month = currentMonth.getMonth();
    
//     const firstDay = new Date(year, month, 1);
//     const lastDay = new Date(year, month + 1, 0);
//     const daysInMonth = lastDay.getDate();
//     const startingDayOfWeek = firstDay.getDay();
    
//     const days = [];
    
//     // Add empty cells for days before the first day of the month
//     for (let i = 0; i < startingDayOfWeek; i++) {
//       days.push(null);
//     }
    
//     // Add all days of the month
//     for (let day = 1; day <= daysInMonth; day++) {
//       const date = new Date(year, month, day);
//       days.push(date);
//     }
    
//     return days;
//   };

//   // Navigate months
//   const goToPreviousMonth = () => {
//     const newMonth = new Date(currentMonth);
//     newMonth.setMonth(newMonth.getMonth() - 1);
//     setCurrentMonth(newMonth);
//   };

//   const goToNextMonth = () => {
//     const newMonth = new Date(currentMonth);
//     newMonth.setMonth(newMonth.getMonth() + 1);
//     setCurrentMonth(newMonth);
//   };

//   // Check if date is selectable
//   const isDateSelectable = (date) => {
//     if (!date) return false;
    
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
    
//     // Date must be in the future
//     if (date < today) return false;
    
//     // Date must be within 4 months from now
//     const fourMonthsFromNow = new Date(today);
//     fourMonthsFromNow.setMonth(fourMonthsFromNow.getMonth() + 4);
    
//     if (date > fourMonthsFromNow) return false;
    
//     // Check if date is within doctor's schedule
//     if (doctorSchedule) {
//       const dateStr = date.toISOString().split('T')[0];
//       const scheduleStartStr = doctorSchedule.startDate.toISOString().split('T')[0];
//       const scheduleEndStr = doctorSchedule.endDate.toISOString().split('T')[0];
      
//       if (dateStr < scheduleStartStr || dateStr > scheduleEndStr) {
//         return false;
//       }
//     }
    
//     return true;
//   };

//   const isToday = (date) => {
//     if (!date) return false;
//     const today = new Date();
//     return date.toDateString() === today.toDateString();
//   };

//   const handleDateSelect = (date) => {
//     if (!isDateSelectable(date)) return;
//     setSelectedDate(date);
//   };

//   const handleContinue = () => {
//     if (!selectedDate) {
//       toast.error("Please select a date");
//       return;
//     }
    
//     if (onDateSelect) {
//       onDateSelect({
//         date: selectedDate,
//         doctor: doctor,
//         schedule: doctorSchedule
//       });
//     }
//   };

//   const handleModalClose = () => {
//     setCurrentMonth(new Date());
//     setSelectedDate(null);
//     setDoctorSchedule(null);
//     handleClose();
//   };

//   const formatDate = (date) => {
//     return date.toLocaleDateString('en-US', { 
//       weekday: 'long',
//       month: 'long', 
//       day: 'numeric',
//       year: 'numeric'
//     });
//   };

//   const calendarDays = generateCalendarDays();
//   const monthYearDisplay = currentMonth.toLocaleDateString('en-US', { 
//     month: 'long', 
//     year: 'numeric' 
//   });

//   return (
//     <Modal show={show} onHide={handleModalClose} size="lg" centered>
//       <div style={styles.modalContent}>
//         <Modal.Header closeButton style={styles.modalHeader}>
//           <div style={styles.doctorInfo}>
//             <div style={styles.doctorAvatar}>
//               {doctor.First?.charAt(0)}{doctor.Last?.charAt(0)}
//             </div>
//             <div style={styles.doctorDetails}>
//               <h4 style={styles.doctorName}>Dr. {doctor.First} {doctor.Last}</h4>
//               <p style={styles.doctorSpeciality}>{doctor.Speciality}</p>
//             </div>
//           </div>
//         </Modal.Header>

//         <Modal.Body style={styles.modalBody}>
//           {/* Progress Bar */}
//           <div style={styles.progressBar}>
//             <div style={styles.progressStep}>
//               <div style={{
//                 ...styles.progressCircle,
//                 ...styles.progressCircleActive
//               }}>
//                 1
//               </div>
//               <div style={{
//                 ...styles.progressLabel,
//                 ...styles.progressLabelActive
//               }}>
//                 Select Date
//               </div>
//             </div>

//             <div style={styles.progressStep}>
//               <div style={styles.progressCircle}>
//                 2
//               </div>
//               <div style={styles.progressLabel}>
//                 Select Time
//               </div>
//             </div>

//             <div style={styles.progressStep}>
//               <div style={styles.progressCircle}>
//                 3
//               </div>
//               <div style={styles.progressLabel}>
//                 Verify & Book
//               </div>
//             </div>
//           </div>

//           {/* Step 1: Select Date */}
//           <div style={styles.stepContainer}>
//             <h5 style={styles.stepTitle}>
//               Select Appointment Date
//             </h5>

//             {loading ? (
//               <div style={{textAlign: 'center', padding: '40px'}}>
//                 <Spinner animation="border" variant="primary" />
//                 <p style={{marginTop: '10px', color: '#666'}}>Loading doctor's schedule...</p>
//               </div>
//             ) : (
//               <>
//                 {/* Calendar Controls */}
//                 <div style={styles.calendarControls}>
//                   <button 
//                     style={styles.navButton}
//                     onClick={goToPreviousMonth}
//                     disabled={currentMonth.getMonth() === new Date().getMonth() && 
//                              currentMonth.getFullYear() === new Date().getFullYear()}
//                   >
//                     ← Previous
//                   </button>
//                   <div style={styles.monthYearDisplay}>
//                     {monthYearDisplay}
//                   </div>
//                   <button 
//                     style={styles.navButton}
//                     onClick={goToNextMonth}
//                   >
//                     Next →
//                   </button>
//                 </div>

//                 {/* Calendar Grid */}
//                 <div style={styles.calendarGrid}>
//                   {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
//                     <div key={day} style={styles.calendarDay}>
//                       {day}
//                     </div>
//                   ))}
                  
//                   {calendarDays.map((date, index) => {
//                     if (!date) {
//                       return <div key={`empty-${index}`} style={{...styles.dateCell, visibility: 'hidden'}}></div>;
//                     }
                    
//                     const selectable = isDateSelectable(date);
//                     const isSelected = selectedDate && selectedDate.toDateString() === date.toDateString();
//                     const isTodayDate = isToday(date);
                    
//                     return (
//                       <div
//                         key={index}
//                         style={{
//                           ...styles.dateCell,
//                           ...(!selectable ? styles.dateCellDisabled : {}),
//                           ...(isSelected ? styles.dateCellSelected : {}),
//                           ...(isTodayDate ? styles.dateCellToday : {})
//                         }}
//                         onClick={() => handleDateSelect(date)}
//                       >
//                         <div style={{
//                           ...styles.dateNumber,
//                           color: !selectable ? '#ccc' : '#333'
//                         }}>
//                           {date.getDate()}
//                         </div>
//                         {isTodayDate && selectable && (
//                           <div style={styles.dateIndicator}>Today</div>
//                         )}
//                       </div>
//                     );
//                   })}
//                 </div>

//                 {doctorSchedule && (
//                   <Alert variant="info" style={{marginTop: '20px'}}>
//                     <strong>Schedule Information:</strong><br />
//                     Available from {doctorSchedule.startDate.toLocaleDateString()} to {doctorSchedule.endDate.toLocaleDateString()}
//                   </Alert>
//                 )}

//                 {selectedDate && (
//                   <div style={{...styles.highlightBox, marginTop: '20px'}}>
//                     <strong>Selected Date:</strong> {formatDate(selectedDate)}
//                     {doctorSchedule?.morningStartTime && doctorSchedule?.eveningStartTime && (
//                       <div style={{marginTop: '10px', fontSize: '14px'}}>
//                         <strong>Available Timings:</strong><br />
//                         Morning: {doctorSchedule.morningStartTime} - {doctorSchedule.morningEndTime}<br />
//                         Evening: {doctorSchedule.eveningStartTime} - {doctorSchedule.eveningEndTime}
//                       </div>
//                     )}
//                   </div>
//                 )}

//                 <div style={{marginTop: '30px', textAlign: 'center'}}>
//                   <Button 
//                     style={styles.btnPrimary}
//                     onClick={handleContinue}
//                     disabled={!selectedDate}
//                   >
//                     Continue to Time Selection →
//                   </Button>
//                 </div>
//               </>
//             )}
//           </div>
//         </Modal.Body>

//         <Modal.Footer style={{backgroundColor: 'white', padding: '20px 30px', borderTop: '1px solid #e0e0e0'}}>
//           <Button variant="outline-danger" onClick={handleModalClose}>
//             Cancel
//           </Button>
//         </Modal.Footer>
//       </div>
//     </Modal>
//   );
// };

// export default DatePickerModal;


import React, { useState, useEffect } from "react";
import { Modal, Button, Alert, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { getDatabase, ref, get } from "firebase/database";
import { app } from "../../../Doctor/Firebase/firebase.config";

const database = getDatabase(app);

// ==================== STYLES ====================
const styles = {
  modalContent: {
    borderRadius: '16px',
    border: 'none',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden'
  },
  modalHeader: {
    background: 'linear-gradient(135deg, #4285f4 0%, #34a853 100%)',
    color: 'white',
    padding: '20px 30px',
    borderBottom: 'none'
  },
  doctorInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px'
  },
  doctorAvatar: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#4285f4'
  },
  doctorDetails: {
    flex: 1
  },
  doctorName: {
    fontSize: '20px',
    fontWeight: '600',
    margin: 0,
    color: 'white'
  },
  doctorSpeciality: {
    fontSize: '14px',
    opacity: 0.9,
    margin: 0,
    color: 'white'
  },
  modalBody: {
    padding: '30px',
    backgroundColor: '#f8f9fa',
    minHeight: '500px'
  },
  progressBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '30px',
    position: 'relative',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)'
  },
  progressStep: {
    flex: 1,
    textAlign: 'center',
    position: 'relative',
    zIndex: 2
  },
  progressCircle: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: '#e0e0e0',
    color: '#666',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 8px',
    fontWeight: 'bold',
    fontSize: '16px',
    transition: 'all 0.3s ease'
  },
  progressCircleActive: {
    backgroundColor: '#4285f4',
    color: 'white',
    boxShadow: '0 4px 12px rgba(66, 133, 244, 0.4)'
  },
  progressLabel: {
    fontSize: '12px',
    color: '#666',
    fontWeight: '500'
  },
  progressLabelActive: {
    color: '#4285f4',
    fontWeight: '600'
  },
  stepContainer: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
    minHeight: '400px'
  },
  stepTitle: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#333',
    marginBottom: '25px',
    paddingBottom: '15px',
    borderBottom: '3px solid #4285f4'
  },
  calendarControls: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    padding: '15px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px'
  },
  monthYearDisplay: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333'
  },
  navButton: {
    backgroundColor: '#4285f4',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '600',
    transition: 'all 0.2s ease'
  },
  calendarGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '8px',
    marginBottom: '20px'
  },
  calendarDay: {
    textAlign: 'center',
    padding: '8px',
    fontSize: '12px',
    fontWeight: '600',
    color: '#666',
    backgroundColor: '#f1f3f4',
    borderRadius: '4px'
  },
  dateCell: {
    minHeight: '60px',
    padding: '8px',
    borderRadius: '8px',
    border: '2px solid #e0e0e0',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dateCellDisabled: {
    backgroundColor: '#f5f5f5',
    color: '#ccc',
    cursor: 'not-allowed',
    border: '2px solid #f0f0f0'
  },
  dateCellSelected: {
    border: '2px solid #4285f4',
    backgroundColor: '#e8f0fe',
    transform: 'scale(1.05)'
  },
  dateCellToday: {
    border: '2px solid #34a853',
    fontWeight: 'bold'
  },
  dateNumber: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333'
  },
  dateIndicator: {
    fontSize: '10px',
    color: '#4285f4',
    marginTop: '2px'
  },
  highlightBox: {
    backgroundColor: '#e8f0fe',
    padding: '15px',
    borderRadius: '8px',
    marginBottom: '15px',
    border: '1px solid #4285f4'
  },
  btnPrimary: {
    backgroundColor: '#4285f4',
    border: 'none',
    padding: '12px 30px',
    fontSize: '15px',
    fontWeight: '600',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#3367d6',
      transform: 'translateY(-2px)'
    }
  }
};

const DatePickerModal = ({ show, handleClose, doctor, onDateSelect }) => {
  const [loading, setLoading] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(null);
  const [doctorSchedule, setDoctorSchedule] = useState(null);
  
  // Fetch doctor schedule
  useEffect(() => {
    if (!doctor || !show || !doctor.uid) return;

    const fetchScheduleData = async () => {
      try {
        setLoading(true);
        
        console.log("Fetching schedule for doctor:", doctor.uid);
        
        const scheduleRef = ref(database, `doctor/${doctor.uid}/schedule`);
        const scheduleSnapshot = await get(scheduleRef);
        
        if (scheduleSnapshot.exists()) {
          const scheduleData = scheduleSnapshot.val();
          console.log("Raw schedule data:", scheduleData);
          
          // Get the first schedule object
          const scheduleKeys = Object.keys(scheduleData);
          if (scheduleKeys.length > 0) {
            const firstSchedule = scheduleData[scheduleKeys[0]];
            setDoctorSchedule({
              ...firstSchedule,
              startDate: new Date(firstSchedule.startDate || new Date()),
              endDate: new Date(firstSchedule.endDate || new Date(Date.now() + 120 * 24 * 60 * 60 * 1000)) // Default 120 days
            });
            console.log("Processed schedule:", firstSchedule);
          }
        } else {
          console.log("No schedule found for this doctor");
          toast.warning("Doctor schedule not available. Please ask the doctor to set their schedule.");
        }
      } catch (error) {
        console.error("Error fetching schedule:", error);
        toast.error("Failed to load schedule");
      } finally {
        setLoading(false);
      }
    };

    fetchScheduleData();
  }, [doctor, show]);

  // Generate calendar days
  const generateCalendarDays = () => {
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth();
    
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();
    
    const days = [];
    
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    
    // Add all days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      days.push(date);
    }
    
    return days;
  };

  // Navigate months
  const goToPreviousMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() - 1);
    setCurrentMonth(newMonth);
  };

  const goToNextMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() + 1);
    setCurrentMonth(newMonth);
  };

  // Check if date is selectable
  const isDateSelectable = (date) => {
    if (!date) return false;
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    // Date must be in the future
    if (date < today) return false;
    
    // Date must be within 4 months from now
    const fourMonthsFromNow = new Date(today);
    fourMonthsFromNow.setMonth(fourMonthsFromNow.getMonth() + 4);
    
    if (date > fourMonthsFromNow) return false;
    
    // Check if date is within doctor's schedule
    if (doctorSchedule) {
      const dateStr = date.toISOString().split('T')[0];
      const scheduleStart = doctorSchedule.startDate ? new Date(doctorSchedule.startDate).toISOString().split('T')[0] : null;
      const scheduleEnd = doctorSchedule.endDate ? new Date(doctorSchedule.endDate).toISOString().split('T')[0] : null;
      
      if (scheduleStart && scheduleEnd) {
        if (dateStr < scheduleStart || dateStr > scheduleEnd) {
          return false;
        }
      }
    }
    
    return true;
  };

  const isToday = (date) => {
    if (!date) return false;
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const handleDateSelect = (date) => {
    if (!isDateSelectable(date)) return;
    setSelectedDate(date);
  };

  const handleContinue = () => {
    if (!selectedDate) {
      toast.error("Please select a date");
      return;
    }
    
    if (onDateSelect) {
      onDateSelect({
        date: selectedDate,
        doctor: doctor,
        schedule: doctorSchedule
      });
    }
  };

  const handleModalClose = () => {
    setCurrentMonth(new Date());
    setSelectedDate(null);
    setDoctorSchedule(null);
    handleClose();
  };

  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString('en-US', { 
      weekday: 'long',
      month: 'long', 
      day: 'numeric',
      year: 'numeric'
    });
  };

  const calendarDays = generateCalendarDays();
  const monthYearDisplay = currentMonth.toLocaleDateString('en-US', { 
    month: 'long', 
    year: 'numeric' 
  });

  return (
    <Modal show={show} onHide={handleModalClose} size="lg" centered>
      <div style={styles.modalContent}>
        <Modal.Header closeButton style={styles.modalHeader}>
          <div style={styles.doctorInfo}>
            <div style={styles.doctorAvatar}>
              {doctor?.First?.charAt(0) || 'D'}{doctor?.Last?.charAt(0) || 'R'}
            </div>
            <div style={styles.doctorDetails}>
              <h4 style={styles.doctorName}>
                Dr. {doctor?.First || ''} {doctor?.Last || ''}
              </h4>
              <p style={styles.doctorSpeciality}>
                {doctor?.Speciality || 'General Physician'}
              </p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body style={styles.modalBody}>
          {/* Progress Bar */}
          <div style={styles.progressBar}>
            <div style={styles.progressStep}>
              <div style={{
                ...styles.progressCircle,
                ...styles.progressCircleActive
              }}>
                1
              </div>
              <div style={{
                ...styles.progressLabel,
                ...styles.progressLabelActive
              }}>
                Select Date
              </div>
            </div>

            <div style={styles.progressStep}>
              <div style={styles.progressCircle}>
                2
              </div>
              <div style={styles.progressLabel}>
                Select Time
              </div>
            </div>

            <div style={styles.progressStep}>
              <div style={styles.progressCircle}>
                3
              </div>
              <div style={styles.progressLabel}>
                Verify & Book
              </div>
            </div>
          </div>

          {/* Step 1: Select Date */}
          <div style={styles.stepContainer}>
            <h5 style={styles.stepTitle}>
              Select Appointment Date
            </h5>

            {loading ? (
              <div style={{textAlign: 'center', padding: '40px'}}>
                <Spinner animation="border" variant="primary" />
                <p style={{marginTop: '10px', color: '#666'}}>Loading doctor's schedule...</p>
              </div>
            ) : (
              <>
                {/* Calendar Controls */}
                <div style={styles.calendarControls}>
                  <button 
                    style={styles.navButton}
                    onClick={goToPreviousMonth}
                    disabled={currentMonth.getMonth() === new Date().getMonth() && 
                             currentMonth.getFullYear() === new Date().getFullYear()}
                  >
                    ← Previous
                  </button>
                  <div style={styles.monthYearDisplay}>
                    {monthYearDisplay}
                  </div>
                  <button 
                    style={styles.navButton}
                    onClick={goToNextMonth}
                  >
                    Next →
                  </button>
                </div>

                {/* Calendar Grid */}
                <div style={styles.calendarGrid}>
                  {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day) => (
                    <div key={day} style={styles.calendarDay}>
                      {day}
                    </div>
                  ))}
                  
                  {calendarDays.map((date, index) => {
                    if (!date) {
                      return <div key={`empty-${index}`} style={{...styles.dateCell, visibility: 'hidden'}}></div>;
                    }
                    
                    const selectable = isDateSelectable(date);
                    const isSelected = selectedDate && selectedDate.toDateString() === date.toDateString();
                    const isTodayDate = isToday(date);
                    
                    return (
                      <div
                        key={index}
                        style={{
                          ...styles.dateCell,
                          ...(!selectable ? styles.dateCellDisabled : {}),
                          ...(isSelected ? styles.dateCellSelected : {}),
                          ...(isTodayDate ? styles.dateCellToday : {})
                        }}
                        onClick={() => handleDateSelect(date)}
                      >
                        <div style={{
                          ...styles.dateNumber,
                          color: !selectable ? '#ccc' : '#333'
                        }}>
                          {date.getDate()}
                        </div>
                        {isTodayDate && selectable && (
                          <div style={styles.dateIndicator}>Today</div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {doctorSchedule && (
                  <Alert variant="info" style={{marginTop: '20px'}}>
                    <strong>Schedule Information:</strong><br />
                    Available from {formatDate(doctorSchedule.startDate)} to {formatDate(doctorSchedule.endDate)}
                  </Alert>
                )}

                {selectedDate && (
                  <div style={{...styles.highlightBox, marginTop: '20px'}}>
                    <strong>Selected Date:</strong> {formatDate(selectedDate)}
                    {doctorSchedule?.morningStartTime && doctorSchedule?.eveningStartTime && (
                      <div style={{marginTop: '10px', fontSize: '14px'}}>
                        <strong>Available Timings:</strong><br />
                        Morning: {doctorSchedule.morningStartTime} - {doctorSchedule.morningEndTime}<br />
                        Evening: {doctorSchedule.eveningStartTime} - {doctorSchedule.eveningEndTime}
                      </div>
                    )}
                  </div>
                )}

                <div style={{marginTop: '30px', textAlign: 'center'}}>
                  <Button 
                    style={styles.btnPrimary}
                    onClick={handleContinue}
                    disabled={!selectedDate}
                  >
                    Continue to Time Selection →
                  </Button>
                </div>
              </>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer style={{backgroundColor: 'white', padding: '20px 30px', borderTop: '1px solid #e0e0e0'}}>
          <Button variant="outline-danger" onClick={handleModalClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default DatePickerModal;